import { create } from 'zustand';
import { combine } from 'zustand/middleware';

import { Ability, ConsoleRules } from '@cast/shared-ability-data-access';

type AbilityStateBase = {
  ability?: Ability;
  rules: ConsoleRules[];
};

const initialState: AbilityStateBase = {
  rules: [],
};

const useAbilityState = create(
  combine(initialState, (set) => ({
    setAbilityState: (ability: Ability, rules: ConsoleRules[]) =>
      set({ ability, rules }),
  }))
);

export const getAbility = () => useAbilityState.getState().ability;
export const setAbilityState = (ability: Ability, rules: ConsoleRules[]) =>
  useAbilityState.getState().setAbilityState(ability, rules);

export const subscribeAbilityState = useAbilityState.subscribe;

export const useRules = () => useAbilityState(({ rules }) => rules);
